import styled, { css } from 'styled-components/macro'
import CirclesImg from '../assets/circles.svg'
import { motion } from 'framer-motion'
import { mq } from 'styles/mq'

export const Container = styled.div`
  position: relative;
`

export type Align = 'left' | 'center' | 'right'

export const Circle = styled(motion.div)<{ $align: Align }>`
  aspect-ratio: 1265 / 1000;
  width: 66.666vw;
  max-width: 121.9rem;
  background: url(${CirclesImg}) 0% center/200% auto no-repeat;

  ${mq.medium} {
    aspect-ratio: 1265 / 472;
    width: 140vw;
    background-position: center center;
    background-size: contain;
  }
`

export const CircleWrapper = styled.div<{ $align: Align }>`
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: -1;

  ${props =>
    props.$align !== 'center' &&
    css`
      left: 31%;
      transform: translate(0, -50%);

      ${mq.medium} {
        left: 50%;
      }
    `}

  ${props =>
    props.$align === 'left' &&
    css`
      left: auto;
      right: 31%;

      ${mq.smallOnly} {
        ${Circle} {
          background-position: 100% center;
        }
      }

      ${mq.medium} {
        left: auto;
        right: 50%;
      }
    `}
`
